<template>
  <subAccountCommonDialog class="sub-permission-dialog" :visible.sync="visible" title="账号权限" @clickCancel="clickCancel" @clickConfirm="clickConfirm">
    <template v-slot:dialogContent>
      <span class="title">报纸管理权限：</span>
      <el-radio class="number-radio" v-model="radioValue" :label="1">有权限</el-radio>
      <el-radio class="number-radio" v-model="radioValue" :label="0">无权限</el-radio>
    </template>
  </subAccountCommonDialog>
</template>
<script>
import subAccountCommonDialog from './subAccountCommonDialog.vue'
export default {
  name: 'subPermissionModifyDialog',
  props: ['visible', 'permission'],
  data() {
    return {
      radioValue: this.permission,
      inputValue: undefined
    }
  },
  methods: {
    clickCancel() {
      this.$emit('clickCancel')
    },
    clickConfirm() {
      this.$emit('clickConfirm', this.radioValue)
    }
  },
  components: {
    subAccountCommonDialog
  }
}
</script>
<style lang="scss" scoped>
.sub-permission-dialog {
  .title {
    color: #000;
  }
  .number-radio {
    margin-right: 16px;
  }
}
</style>
